'use client';
import { styled } from '@mui/material/styles';
import {
  Stepper as MuiStepper,
  StepperProps,
  Step as MuiStep,
  StepProps,
  StepLabel as MuiStepLabel,
  StepLabelProps,
  StepContent as MuiStepContent,
  StepContentProps,
} from '@mui/material';

const StyledStepper = styled(MuiStepper)<StepperProps>({});
const StyledStep = styled(MuiStep)<StepProps>({});
const StyledStepLabel = styled(MuiStepLabel)<StepLabelProps>({});
const StyledStepContent = styled(MuiStepContent)<StepContentProps>({});

export const Stepper = (props: StepperProps) => <StyledStepper {...props} />;
export const Step = (props: StepProps) => <StyledStep {...props} />;
export const StepLabel = (props: StepLabelProps) => <StyledStepLabel {...props} />;
export const StepContent = (props: StepContentProps) => <StyledStepContent {...props} />;
